module.exports = __webpack_public_path__ + "img/icon_store.bf60aa87.svg";